import styled, { css } from 'styled-components';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

export const StepsWrapper = styled.div`
	${flex({ jc: 'flex-start' })}
	gap: 1rem;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.configurator.color.primary};
	font-weight: ${({ theme }) => theme.font.medium};
	width: 100%;

	${customMinResponsive(
		size.semi,
		css`
			width: auto;
		`
	)}
`;

export const StepButton = styled.button<{ isActive?: boolean }>`
	${flex()}
	border: 2px solid ${({ theme }) => theme.configurator.color.primary};
	background-color: ${({ theme }) => theme.configurator.bg.primary};
	color: ${({ theme }) => theme.configurator.steps.color.default};
	border-radius: 50%;
	width: 3.6rem;
	height: 3.6rem;
	cursor: pointer;
	transition: 300ms ease-in-out;

	&:disabled {
		opacity: 0.3;
		cursor: not-allowed;
	}

	${({ theme, isActive }) =>
		isActive &&
		css`
			color: ${theme.configurator.steps.color.active};
			background-color: ${theme.configurator.bg.contrast};
		`}
`;
